import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

function Register() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    companyName: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await register(formData.email, formData.password, formData.companyName);
      navigate('/dashboard');
    } catch (error) {
      setError(error.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          width: '100%',
          maxWidth: 400,
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        {/* Brand */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 4 }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #2A6BDB 0%, #1E4FA0 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M10 2L3 5v5c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9V5l-7-3z" strokeLinejoin="round" />
            </svg>
          </Box>
          <Typography sx={{ fontWeight: 700, fontSize: '1.25rem', color: 'text.primary' }}>
            Startup Assist-Pro
          </Typography>
        </Box>

        <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
          Create account
        </Typography>
        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', mb: 3 }}>
          Get started with your AWS automation platform
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: 'text.primary', mb: 0.5 }}>
            Company name
          </Typography>
          <TextField
            required
            fullWidth
            id="companyName"
            name="companyName"
            placeholder="Acme Inc."
            autoFocus
            value={formData.companyName}
            onChange={handleChange}
            size="small"
            sx={{ mb: 2 }}
          />

          <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: 'text.primary', mb: 0.5 }}>
            Email
          </Typography>
          <TextField
            required
            fullWidth
            id="email"
            name="email"
            autoComplete="email"
            placeholder="you@company.com"
            value={formData.email}
            onChange={handleChange}
            size="small"
            sx={{ mb: 2 }}
          />

          <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: 'text.primary', mb: 0.5 }}>
            Password
          </Typography>
          <TextField
            required
            fullWidth
            name="password"
            type="password"
            id="password"
            placeholder="Create a password"
            value={formData.password}
            onChange={handleChange}
            size="small"
            sx={{ mb: 2 }}
          />

          <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: 'text.primary', mb: 0.5 }}>
            Confirm password
          </Typography>
          <TextField
            required
            fullWidth
            name="confirmPassword"
            type="password"
            id="confirmPassword"
            placeholder="Confirm your password"
            value={formData.confirmPassword}
            onChange={handleChange}
            size="small"
            sx={{ mb: 3 }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{ py: 1.2, mb: 2 }}
          >
            {loading ? 'Creating account...' : 'Create account'}
          </Button>

          <Typography sx={{ textAlign: 'center', fontSize: '0.8125rem', color: 'text.secondary' }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: '#2A6BDB', textDecoration: 'none', fontWeight: 500 }}>
              Sign in
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}

export default Register;
